module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com (4).d5739bb1.svg";